// extracted by mini-css-extract-plugin
module.exports = {"inverted":"Articles_inverted__o9kjL","navbarExpanded":"Articles_navbarExpanded__4VGS0","articles":"Articles_articles__N_J9Q"};